module.exports = __webpack_public_path__ + "img/acomerclub.689b1e2c.webp";